import request from '#/utils/request';
import { withFmsActor } from '#/api/fmsMgmt/fmsActorConfig';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** PATCH `/fms/payment-requests/{id}/remark`。body：`remark`、`updatedAt`。 */
export async function updatePaymentRequestRemark(id, payload) {
  const { data: raw } = await request.patch(
    `/fms/payment-requests/${id}/remark`,
    keysToSnake(payload),
    withFmsActor(),
  );
  return parseVer4DetailResponse(raw);
}
